// Setup PageFind

export default function initSearch() {
  window.addEventListener('DOMContentLoaded', (_) => {
    new PagefindUI({
      element: '#search',
      showSubResults: true,
      showImages: false,
    })
  })
}
